module.exports = __webpack_public_path__ + "img/certification.4c22be69.png";